// src/store/store.ts
import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import reducers from "../reducer"
import userProfileReducer from './slices/userProfileSlice'
import { persistStore, persistReducer } from 'redux-persist'

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['login', 'userProfile'] // persist both login and userProfile
}

const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
    reducer: {
        data: persistedReducer,
        userProfile: userProfileReducer, // Add user profile reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
})

export const persistor = persistStore(store)

// Export types for TypeScript support
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch